import { useCallback } from 'react';
import { CALENDLY_CONFIG } from './calendlyConfig';
import { useCalendlyLoader } from './useCalendlyLoader';

export const useOpenCalendly = () => {
  const { safeOpenCalendlyPopup } = useCalendlyLoader();

  const openCalendly = useCallback(async () => {
    await safeOpenCalendlyPopup(CALENDLY_CONFIG.url);
  }, [safeOpenCalendlyPopup]);

  return openCalendly;
};
